import React, { SVGProps } from 'react'

export default function KelpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 2400 2400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="1199.5" cy="1200.5" r="1137.5" fill={props.fill ?? '#CA4326'} />
      <path d="M1473.43 1583.8H926.215V1693H1473.43V1583.8Z" fill="white" />
      <path d="M1145.1 1255.57H1035.66V1364.77H1145.1V1255.57Z" fill="white" />
      <path d="M1364 1255.57H1254.55V1364.77H1364V1255.57Z" fill="white" />
      <path d="M1473.43 708H926.215V817.201H1473.43V708Z" fill="white" />
      <path d="M1254.55 1365.07H1145.11V1474.28H1254.55V1365.07Z" fill="white" />
      <path d="M1254.55 927.029H1145.11V1036.23H1254.55V927.029Z" fill="white" />
      <path d="M1364 1036.53H1254.55V1145.74H1364V1036.53Z" fill="white" />
      <path d="M1145.1 1036.53H1035.66V1145.74H1145.1V1036.53Z" fill="white" />
      <path d="M1692 926.712H1582.56V1474.28H1692V926.712Z" fill="white" />
      <path
        d="M816.443 1145.74V926.712H707V1145.74H707.317V1474.28H816.761V1145.74H816.443Z"
        fill="white"
      />
    </svg>
  )
}
